import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getPasswordExpiryPeriod = (tenantName) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ORGANIZATION_SETTINGS.GET_PASSWORD_EXPIRY_PERIOD(
      tenantName
    )
  );
};

export default getPasswordExpiryPeriod;
